import { CommonHeader } from "../Common/CommonHeader";

export default function WhyRd() {
  return (
    <>
      <CommonHeader title="WHY PUBLISHED WITH RESEARCH DISCOURSE" />
    </>
  );
}
